"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icons = void 0;
var close_1 = require("./close");
var print_1 = require("./print");
var download_1 = require("./download");
var related_1 = require("./related");
var message_1 = require("./message");
var share_1 = require("./share");
var more_1 = require("./more");
var quiz_1 = require("./quiz");
var switch_1 = require("./switch");
var add_1 = require("./add");
var minimizedVideo_1 = require("./minimizedVideo");
var pictureInPicture_1 = require("./pictureInPicture");
var expand_1 = require("./expand");
var arrowOpen_1 = require("./arrowOpen");
var arrowClose_1 = require("./arrowClose");
var chapter_1 = require("./chapter");
var hotspot_1 = require("./hotspot");
var answerOnAir_1 = require("./answerOnAir");
exports.Icons = {
    close: close_1.Close,
    print: print_1.Print,
    download: download_1.Download,
    related: related_1.Related,
    message: message_1.Message,
    share: share_1.Share,
    more: more_1.More,
    quiz: quiz_1.QuizIcon,
    switch: switch_1.Switch,
    add: add_1.Add,
    minimizedVideo: minimizedVideo_1.MinimizedVideo,
    pictureInPicture: pictureInPicture_1.PictureInPicture,
    expand: expand_1.Expand,
    arrowOpen: arrowOpen_1.ArrowOpen,
    arrowClose: arrowClose_1.ArrowClose,
    chapter: chapter_1.Chapter,
    hotspot: hotspot_1.Hotspot,
    answerOnAir: answerOnAir_1.AnswerOnAir
};
//# sourceMappingURL=index.js.map